import {
  isUserLoggedIn,
  getUserData,
  getGrupoAcesso,
  hasPermissao,
} from '@/auth/utils';

function retrieveRoutes() {
  let menuItems = [];
  const userData = getUserData();
  if (userData?.grupoAcesso?.presencialInloco)
    menuItems = [
      {
        title: 'Cadastro',
        icon: 'UserPlusIcon',
        route: 'PresencialInlocoCadastro',
        meta: {
          requiresParametrizacao: false,
        },
      },
      {
        title: 'Importação',
        icon: 'HardDriveIcon',
        children: [
          {
            title: 'Parametrizações',
            route: 'PresencialInlocoImportarParametrizacoes',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Novos Cadastros',
            route: 'PresencialInlocoImportarNovosCadastros',
            meta: {
              requiresParametrizacao: true,
            },
            modal: 'importarNovosCadastrosEvent',
          },
          {
            title: 'Agendamentos',
            route: 'PresencialInlocoImportarAgendamentos',
            meta: {
              requiresParametrizacao: true,
            },
            modal: 'importarAgendamentosEvent',
          },
        ],
      },
      {
        title: 'Triagem',
        icon: 'CheckSquareIcon',
        route: 'PresencialInlocoTriagem',
        meta: {
          requiresParametrizacao: true,
        },
      },
    ];
  else
    menuItems = [
      {
        title: 'Cadastro',
        icon: 'UserPlusIcon',
        meta: {
          requiresParametrizacao: false,
        },
        children: [
          {
            title: 'Alíquotas',
            route: 'CadastroAliquotas',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Cargos',
            route: 'CadastroCargos',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Financeiro',
            route: 'CadastroFinanceiro',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Instituto',
            route: 'CadastroInstituto',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Lotações',
            route: 'CadastroLotacoes',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Órgãos',
            route: 'CadastroOrgaos',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Servidor',
            route: 'CadastroServidor',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Unidades',
            route: 'CadastroUnidades',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Usuário',
            route: 'CadastroUsuario',
            meta: {
              requiresParametrizacao: true,
            },
          },
        ],
      },
      {
        title: 'Auditoria',
        route: 'Auditoria',
        icon: 'CheckSquareIcon',
        meta: {
          requiresParametrizacao: true,
        },
      },
      // {
      //   title: "Auditoria Prova de Vida",
      //   route: "AuditoriaProvaVida",
      //   icon: "CheckSquareIcon",
      // },
      {
        title: 'Controle de Pendências',
        route: 'ReprovadosRejeitados',
        icon: 'AlertOctagonIcon',
        meta: {
          requiresParametrizacao: true,
          formatoBackOffice: true,
        },
      },
      {
        title: 'Relatórios',
        route: 'Relatorios',
        icon: 'BarChartIcon',
        meta: {
          requiresParametrizacao: true,
        },
      },
      {
        title: 'Importação',
        icon: 'HardDriveIcon',
        route: 'ImportarExportar',
        meta: {
          requiresParametrizacao: true,
        },
      },
      {
        title: 'Envio SISPREV',
        icon: 'SendIcon',
        route: 'EnvioSISPREV',
        meta: {
          requiresParametrizacao: true,
        },
      },
      {
        title: 'Configurações',
        icon: 'SettingsIcon',
        children: [
          {
            title: 'Bloqueio Geográfico',
            route: 'ConfiguracoesBloqueioGeografico',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Fila de Trabalho',
            route: 'ConfiguracoesFilaTrabalho',
            meta: {
              requiresParametrizacao: true,
              formatoBackOffice: true,
            },
          },
          {
            title: 'Grupos de Acesso',
            route: 'ConfiguracoesWorkflow',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Ouvidoria',
            route: 'ConfiguracoesOuvidoria',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Parametrização',
            route: 'ConfiguracoesParametrizacao',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Questionário Socioeconômico',
            route: 'ConfiguracoesQuestionario',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Registro de Logs',
            route: 'ConfiguracoesSitemaLog',
            meta: {
              requiresParametrizacao: true,
            },
          },
          {
            title: 'Sistema',
            route: 'ConfiguracoesSistema',
            meta: {
              requiresParametrizacao: true,
            },
          },
        ],
      },
    ];

  menuItems = [
    {
      title: 'Inicial',
      route: 'home',
      icon: 'HomeIcon',
      meta: {
        requiresParametrizacao: false,
      },
    },
    ...menuItems,

    {
      title: 'In loco',
      icon: 'AlertOctagonIcon',
      children: [
        {
          title: 'Configuração dos polos',
          route: 'ConfiguracoesAgendamento',
          meta: {
            requiresParametrizacao: true,
          },
        },
        {
          title: 'Recebimentos In Loco',
          route: 'RecebimentosInLoco',
          meta: {
            requiresParametrizacao: true,
          },
        },
        {
          title: 'Agendamento In Loco',
          route: 'PresencialInlocoAgendamento',
          meta: {
            requiresParametrizacao: true,
          },
        },
        {
          title: 'Atendimento Domiciliar',
          route: 'AtendimentoDomiciliar',
          meta: {
            requiresParametrizacao: true,
          },
        },
      ],
    },
  ];

  const isLoggedIn = isUserLoggedIn();
  if (!isLoggedIn) {
    menuItems.forEach(menu => {
      // for (let i = 0; i < menuItems.length; i++) {
      //   const menu = menuItems[i];
      if (menu.route != undefined) {
        menu.disabled = true;
        menu.hidden = true;
      } else if (menu.children != undefined) {
        // Teste para ver se o problema de demora no carregamento do menu
        for (let j = 0; j < menu.children.length; j++) {
          const child = menu.children[j];
          child.disabled = true;
          child.hidden = true;
        }
        menu.disabled = true;
        menu.hidden = true;
      }
    });

    return menuItems;
  }

  if (userData.role == 'master') {
    return menuItems;
  }

  menuItems.forEach(menu => {
    let route = menu.route;

    if (menu.meta?.requiresParametrizacao && !hasPermissao(route)) {
      menu.disabled = true;
      menu.hidden = true;
      return;
    }

    let allChildrenDisabled = true;
    for (let i = 0; i < menu.children?.length; i++) {
      route = menu.children[i].route;

      if (
        menu.children[i].meta?.requiresParametrizacao &&
        !hasPermissao(route)
      ) {
        menu.children[i].disabled = true;
        menu.children[i].hidden = true;
      } else {
        allChildrenDisabled = false;
      }
      if (
        menu.children[i].meta?.formatoBackOffice ==
        !userData?.institutoSelecionadoData?.formatoBackOffice
      ) {
        menu.children[i].disabled = true;
        menu.children[i].hidden = true;
      }
    }

    if (
      menu.meta?.formatoBackOffice ==
      !userData?.institutoSelecionadoData?.formatoBackOffice
    ) {
      menu.disabled = true;
      menu.hidden = true;
    }

    if (menu.children?.length > 0) {
      if (allChildrenDisabled) {
        menu.disabled = true;
        menu.hidden = true;
      }
    }
  });

  return menuItems;
}

// export const importarNovosCadastros = () => {
//   alert(`aki`);
//   // this.$swal({
//   //   title: "Atenção!",
//   //   text: "Deseja realmente limpar a foto?",
//   //   icon: "warning",
//   //   showCancelButton: true,
//   //   confirmButtonText: "Sim!",
//   //   cancelButtonText: "Não!",
//   //   customClass: {
//   //     confirmButton: "btn btn-primary",
//   //     cancelButton: "btn btn-danger ml-1",
//   //   },
//   //   buttonsStyling: false,
//   // }).then((result) => {
//   //   if (result.isConfirmed) {
//   //     this.passaSelfie = false;
//   //     this.dados = { ...this.dados, selfie: null };
//   //   }
//   // });
// };

// tem que retornar função para poder renderizar ao
// dar update na store user/userData
export default retrieveRoutes;
